import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { CustomChip } from "../../../components/chip/Chip";
import { TAB_AUTORIZAR_ID } from "./GestionEnviosContent";

export const GestionEnviosTabs = ({
    tabs,
    setTabs,
    setRows,
    originalDataAutorizados,
    originalDataAutorizar
}) => {

    const handleClickTab = (id) => {
        const currentTab = tabs.find(tab => tab.active);
        if (currentTab.id === id) return;

        setTabs((prevTabs) => {
            const nueva = prevTabs.map(tab => {
                if (tab.id === id) {
                    return { ...tab, active: true };
                }
                return { ...tab, active: false };
            });

            setRows(id === TAB_AUTORIZAR_ID ? [...originalDataAutorizar] : [...originalDataAutorizados]);

            return [...nueva];

        });
    }

    useEffect(() => {
        setTabs((prevTabs) => (
            prevTabs.map(tab => {
                if (tab.id === TAB_AUTORIZAR_ID) {
                    return { ...tab, count: originalDataAutorizar?.length || 0 };
                }
                return { ...tab, count: originalDataAutorizados?.length || 0 };
            }
            )));
    }, [originalDataAutorizados, originalDataAutorizar]);

    return (
        <Grid
            container
            spacing={2}
        >
            {tabs.map((tab, index) =>
                <Grid
                    key={index}
                    size={{ md: 3 }}
                    className={tab.active ? 'tabActive' : 'tabsHeader'}
                    onClick={() => handleClickTab(tab.id)}
                    sx={{ cursor: 'pointer' }}
                >
                    <p>
                        {tab.name}
                    </p>
                    <CustomChip
                        label={tab.count}
                        isGreen={tab.active}
                        sx={{ marginLeft: '5px', borderRadius: '50%', padding: '2px' }}
                    />
                </Grid>
            )}
        </Grid>
    );
}